module.exports = __webpack_public_path__ + "static/img/glove_marron_fonce.3419268.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_marron_fonce.png
// module id = eVv7
// module chunks = 0